import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/gig-requests')({
  beforeLoad: () => {
    throw redirect({ to: '/profile/my-gigs' });
  },
});
